import { collection, get, all, query, where, set, update } from "typesaurus"

export interface SubCourse {
  id: string
  created: number
  lastModified: number
  name: string
  displayName?: string
  subjectName?: string
  published: boolean
  courseId: string
  node?: string
  index?: number
  sections: {
    [key: string]: number | "-1"
  }
  deleted?: boolean
}

const collection_ref = collection<SubCourse>("subcourses")

export const getSubCoursesById = (id: string) => {
  return get(collection_ref, id)
}

export const getSubCoursesByCourseId = (courseId: string) => {
  return query(collection_ref, [where("courseId", "==", courseId)])
}

export const getAllSubCourses = () => {
  return all(collection_ref)
}

export const updateSubCoursesById = (
  id: string,
  newVals: Partial<SubCourse>
) => {
  return update(collection_ref, id, newVals)
}

export const setSubCoursesById = (id: string, newVals: Partial<SubCourse>) => {
  return set(collection_ref, id, newVals)
}
